import { createSelector } from 'reselect'

const getDatetimes = (state, layerName) => {
  return state.timestamp.timestamps[layerName]
}

const getLayersRendered = (state, layerName) => {
  return state.layer.layersRendered
}

const getLayerName = (state, layerName) => {
  return layerName
}

const getDatetimeId = (state, layerName, datetimeId) => {
  return datetimeId
}

const getSecondary = (state, layerName, datetimeId, secondary) => {
  return secondary
}

export const makeGetLayerDisabled = () => {
  return createSelector(
    [getDatetimes, getLayersRendered, getLayerName, getDatetimeId, getSecondary],
    (datetimes, layersRendered, layerName, datetimeId, secondary) => {
      const layerRendered = layersRendered.includes(layerName)
      if (layerRendered) {
        return false
      }
      if (datetimes) {
        return secondary ? !datetimes.length : false
      } else {
        return secondary ? true: false
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/layerDisabledSelector.js